var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElectricity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.777 28.326a1.667 1.667 0 00-.06-2.282l-1.647-1.648a7.228 7.228 0 00-.615-9.503l-7.114-7.115.143-.144a2.52 2.52 0 10-3.563-3.563L15 6.992l-3.151-3.151a1.734 1.734 0 00-2.453 2.452l3.152 3.151-3.104 3.104-3.15-3.152A1.734 1.734 0 003.84 11.85L6.991 15 4.07 17.922a2.52 2.52 0 003.563 3.563l.144-.143 7.115 7.115a7.217 7.217 0 009.503.615l1.648 1.647a1.656 1.656 0 002.282.06l5.888 5.888h2.452v-2.452l-5.888-5.888zM10.183 5.508a.623.623 0 01.881-.881l3.151 3.15-.88.882-3.152-3.151zm-5.555 5.555a.623.623 0 01.88-.881l3.152 3.151-.881.881-3.151-3.15zm2.365 9.492l-.143.144a1.409 1.409 0 01-1.992-1.993l2.92-2.92 2.453-2.453 3.103-3.103 2.452-2.452 2.921-2.921A1.409 1.409 0 0120.7 6.849l-.144.143L6.992 20.555zm17.33 7.116a6.118 6.118 0 01-8.643 0l-7.116-7.116L20.555 8.563l7.116 7.116a6.118 6.118 0 010 8.642l-3.35 3.35zm3.293 2.262a.555.555 0 01-.786 0l-1.6-1.6 3.104-3.103 1.6 1.6a.555.555 0 010 .785l-2.318 2.318zm7.94 5.622h-.88L29.118 30l.88-.881 5.556 5.555v.881z",
    fill: "var(--color-secondary)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 18.833v2.887l-3.667-3.261a.501.501 0 00-.665.747l4.5 4a.5.5 0 00.833-.373v-2.977l3.693 2.872a.5.5 0 10.613-.79l-4.5-3.5a.5.5 0 00-.806.395z",
    fill: "var(--color-secondary)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricity);
export default __webpack_public_path__ + "static/media/electricity.41102b7ae42b9733e487b0b8e65314c3.svg";
export { ForwardRef as ReactComponent };